import { create } from "zustand";

type UseContentEntityStore = {
  processing: boolean;
  setProcessing: (processing: boolean) => void;
};
const useContentEntityStore = create<UseContentEntityStore>((set) => ({
  processing: false,
  setProcessing: (processing: boolean) => set({ processing }),
}));

export default useContentEntityStore;